"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var selectReplyOption_1 = require("../actions/selectReplyOption");
var store_1 = require("../store/store");
var owa_options_core_1 = require("owa-options-core");
var ChoiceGroup_1 = require("office-ui-fabric-react/lib/ChoiceGroup");
var owa_session_store_1 = require("owa-session-store");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var React = require("react");
var react_1 = require("satcheljs/lib/legacy/react");
var REPLY_KEY = 'Reply';
var REPLY_ALL_KEY = 'ReplyAll';
var ReplyFull = /** @class */ (function (_super) {
    tslib_1.__extends(ReplyFull, _super);
    function ReplyFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (ev, option) {
            selectReplyOption_1.default(option.key === REPLY_ALL_KEY);
        };
        return _this;
    }
    ReplyFull.prototype.render = function () {
        var _a = this.props, optionStore = _a.optionStore, userOptions = _a.userOptions;
        var isReplyAllDefault = owa_options_core_1.getFallbackValueIfNull(optionStore.replyAllByDefault, userOptions.IsReplyAllTheDefaultResponse);
        var selectedKey = isReplyAllDefault ? REPLY_ALL_KEY : REPLY_KEY;
        var choices = [
            {
                key: REPLY_KEY,
                text: owa_options_strings_1.default.options_mail_Reply,
            },
            {
                key: REPLY_ALL_KEY,
                text: owa_options_strings_1.default.options_mail_ReplyAll,
            },
        ];
        return (React.createElement(ChoiceGroup_1.ChoiceGroup, { selectedKey: selectedKey, options: choices, onChange: this.onChange, label: owa_options_strings_1.default.options_mail_ReplyOptionLabel }));
    };
    ReplyFull = tslib_1.__decorate([
        react_1.reactive({
            optionStore: function () { return store_1.default; },
            userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
        })
    ], ReplyFull);
    return ReplyFull;
}(React.Component));
exports.default = ReplyFull;
//# sourceMappingURL=ReplyFull.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-reply-option/lib/components/ReplyFull.js
// module id = 5049
// module chunks = 2